import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import LoadingButton from "../../../../components/Loading/LoadingButton";
import { getMethod, postMethod } from "../../../../function/helper";

export default function RegisterUserSendAuthCode({
  phone = "",
  nationalCode = "",
}) {
  const [editMobile, setEditMobile] = useState(false);

  const { mutate: submitAuthCode, isPending } = useMutation({
    mutationKey: ["registerUserSendAuthCode"],
    mutationFn: body =>
      postMethod("/user/v1/code", {
        code: body.code,
        phone: body.mobile,
        nationalCode,
      }).then(res => {
        if (res && res.status === 200) {
          window.localStorage.clear();
          localStorage.setItem("token", res.data.data);
          window.location.replace("/");
          return;
        }

        Swal.fire({
          icon: "error",
          text: res?.data?.data || res.message,
          showConfirmButton: true,
          confirmButtonText: "متوجه شدم",
        });
      }),
  });

  const { mutate: resendSMSCode, isPending: isSending } = useMutation({
    mutationKey: ["RegisterUserSendAuthCodeNewMobile"],
    mutationFn: body =>
      getMethod("/user/v1/send-auth-sms", {
        nationalCode: body.nationalCode,
        phone: body.mobile,
      }).then(res => {
        if (res && res.status === 200) {
          Swal.fire({
            icon: "success",
            text: res.message,
            showConfirmButton: true,
            confirmButtonText: "متوجه شدم",
          });
          return;
        }

        Swal.fire({
          icon: "error",
          text: res.message,
          showConfirmButton: true,
          confirmButtonText: "متوجه شدم",
        });
      }),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { nationalCode, mobile: phone },
  });

  return (
    <Modal show dir="rtl" centered>
      <form>
        <Modal.Header>
          <Modal.Title className="text-center">
            ثبت نام با موفقیت انجام شد
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div>
            <Form.Label>شماره موبایل</Form.Label>
            <Form.Control
              disabled={!editMobile}
              {...register("mobile", {
                required: "شماره موبایل الزامی",
                minLength: {
                  value: 11,
                  message: "شماره موبایل باید 11 رقم باشد",
                },
                maxLength: {
                  value: 11,
                  message: "شماره موبایل باید 11 رقم باشد",
                },
                validate: {
                  format: v => {
                    if (v[0] !== "0" || v[1] !== "9") {
                      return "شماره موبایل باید با 09 شروع شود";
                    }

                    return true;
                  },
                },
              })}
            />

            {errors.mobile && (
              <p className="text-danger fs-small">{errors.mobile.message}</p>
            )}

            <button
              type="button"
              disabled={isPending || isSending}
              onClick={() => setEditMobile(true)}
              className="buttonUi text-primary fs-small"
            >
              ویرایش شماره موبایل
            </button>
          </div>

          <div className="mt-3">
            <Form.Label>لطفا کد پیامک شده را وارد کنید</Form.Label>
            <Form.Control type="text" {...register("code")} />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <LoadingButton
            onClick={handleSubmit(values => {
              setEditMobile(false);
              submitAuthCode(values);
            })}
            isLoading={isPending}
            disable={isSending || editMobile}
            center
            className="btn-success"
            title={isPending ? "در حال ثبت" : "ثبت کد احراز هویت"}
            type="button"
          />

          <LoadingButton
            onClick={handleSubmit(values => {
              setEditMobile(false);
              resendSMSCode(values);
            })}
            isLoading={isSending}
            disable={isPending}
            center
            className="btn-primary"
            title={isSending ? "در حال ارسال" : "ارسال مجدد پیامک"}
            type="button"
          />
        </Modal.Footer>
      </form>
    </Modal>
  );
}
